import React, { Component } from 'react'

import { assetUrl } from '../../../config';
import AutoVideo from '../../AutoVideo';
import $ from 'jquery';
import { withT } from '../../../i18n';
class HyperReality extends Component {
    server_path = window.src_path;
    constructor() {
        super()
    }

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <AutoVideo controls src={assetUrl('collection/topslide/Hyperreality.mp4')} poster={assetUrl('collection/topslide/Hyperreality.jpg')}></AutoVideo>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">Hyperreality</h2>

                                <h2 className="artist_name"><span>{t('work.by')} </span> Nessgraphics </h2>
                                <div className="desc">
                                    <p>Two seamlessly looping animations within one piece, combining the worlds of futuristic animations within hyperreal nature environments. 2160x2160px.</p>
                                </div>

                                <a href="https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/16131" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(HyperReality);
